import { connect } from "react-redux";
import { Selectors } from "@/store/achieves/selectors";
import { Effects } from "@/store/achieves/effects";

const mSp = (state) => ({
  achievesList: Selectors.getAchieves(state),
});
const mDp = {
  loadAchieves: Effects.loadAchieves,
};

export default connect(mSp, mDp);
